export default __webpack_public_path__ + "static/media/1D.92051c04.png";